const isSimulatedResponse = (data) => {
  if (typeof data !== "object" || data === null) {
    return false;
  }
  const {
    __status
  } = data;
  return typeof __status === "string" && ["error", "pending", "success"].includes(__status);
};
const isError = (data) => {
  if (!isSimulatedResponse(data)) {
    return false;
  }
  return data.__status === "error";
};
const isPending = (data) => {
  if (!isSimulatedResponse(data)) {
    return false;
  }
  return data.__status === "pending";
};
const isSuccess = (data) => {
  if (!isSimulatedResponse(data)) {
    return false;
  }
  return data.__status === "success";
};
export {
  isError,
  isPending,
  isSimulatedResponse,
  isSuccess
};
